import {QueryParamsModel} from './../../_base/crud/models/query-models/query-params.model';
import {forkJoin, of} from 'rxjs';
// Angular
import {Injectable} from '@angular/core';
// RxJS
import {map, mergeMap, tap} from 'rxjs/operators';
// NGRX
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
// CRUD
import {QueryResultsModel} from '../../_base/crud';
// Services
import {ScopesService} from '../_services/';
// State
import {AppState} from '../../reducers';
// Actions
import {
	ManyScopesDeleted,
	OneScopeDeleted,
	ScopeActionToggleLoading,
	ScopeActionTypes,
	ScopeCreated,
	ScopeOnServerCreated,
	ScopesPageLoaded,
	ScopesPageRequested,
	ScopesPageToggleLoading,
	ScopesStatusUpdated,
	ScopeUpdated
} from '../_actions/scope.actions';

@Injectable()
export class ScopeEffects {
	showPageLoadingDistpatcher = new ScopesPageToggleLoading({isLoading: true});
	showActionLoadingDistpatcher = new ScopeActionToggleLoading({isLoading: true});
	hideActionLoadingDistpatcher = new ScopeActionToggleLoading({isLoading: false});

	@Effect()
	loadScopesPage$ = this.actions$.pipe(
		ofType<ScopesPageRequested>(ScopeActionTypes.ScopesPageRequested),
		mergeMap(({payload}) => {
			this.store.dispatch(this.showPageLoadingDistpatcher);
			const requestToServer = this.scopesService.findScopes(payload.page);
			const lastQuery = of(payload.page);
			return forkJoin(requestToServer, lastQuery);
		}),
		map(response => {
			const result: QueryResultsModel = response[0];
			const lastQuery: QueryParamsModel = response[1];
			return new ScopesPageLoaded({
				scopes: result.items,
				totalCount: result.totalCount,
				page: lastQuery
			});
		})
	);

	@Effect()
	deleteScope$ = this.actions$
		.pipe(
			ofType<OneScopeDeleted>(ScopeActionTypes.OneScopeDeleted),
			mergeMap(({payload}) => {
					this.store.dispatch(this.showActionLoadingDistpatcher);
					return this.scopesService.deleteScope(payload.id);
				}
			),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	@Effect()
	deleteScopes$ = this.actions$
		.pipe(
			ofType<ManyScopesDeleted>(ScopeActionTypes.ManyScopesDeleted),
			mergeMap(({payload}) => {
					this.store.dispatch(this.showActionLoadingDistpatcher);
					return this.scopesService.deleteScopes(payload.ids);
				}
			),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	@Effect()
	updateScope$ = this.actions$
		.pipe(
			ofType<ScopeUpdated>(ScopeActionTypes.ScopeUpdated),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showActionLoadingDistpatcher);
				return this.scopesService.updateScope(payload.scope);
			}),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			})
		);

	@Effect()
	updateScopesStatus$ = this.actions$
		.pipe(
			ofType<ScopesStatusUpdated>(ScopeActionTypes.ScopesStatusUpdated),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showActionLoadingDistpatcher);
				return this.scopesService.updateStatusForScope(payload.scopes, payload.status);
			}),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			})
		);

	@Effect()
	createScope$ = this.actions$
		.pipe(
			ofType<ScopeOnServerCreated>(ScopeActionTypes.ScopeOnServerCreated),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showActionLoadingDistpatcher);
				return this.scopesService.createScope(payload.scope).pipe(
					tap(res => {
						this.store.dispatch(new ScopeCreated({scope: res}));
					})
				);
			}),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	constructor(private actions$: Actions, private scopesService: ScopesService, private store: Store<AppState>) {
	}
}
